import { lazy } from 'react';
import { authRoles } from 'app/auth';

const NegativeStockAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: '/apps/settings/negative-stock',
			component: lazy(() => import('./list/NegativeStock'))
		}
	]
};

export default NegativeStockAppConfig;
